import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import { SchoolProvider } from '../context/SchoolContext';

const AppProviders = ({ children }) => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SchoolProvider>{children}</SchoolProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppProviders;
